<template>
    <div class="d-flex justfify-content-between align-items-center">
        <span class="pl-1">
            {{ $t('chooseViewingMode.viewModeOnePage') }}
        </span>
        <b-form-checkbox
            switch
            size="lg"
            :checked="checked"
            @input="$emit('update:checked', $event)"
            @change="$emit('change', $event)"
            class="d-inline-block ml-auto"
        />
    </div>
</template>

<script>
export default {
    name: 'ChooseViewingMode',
    props: ['checked'],
}
</script>
